// shared obj w/ countertop scene
import { flexMultiPrep } from './data-shared/flexMultiPrep.js';
// recipes
import { flexPlus } from './recipes/flexPlus.js';
import { largeMuffinPan } from './recipes/largeMuffinPan.js';
import { springFormPan } from './recipes/springFormPan.js';
import { handPie } from './recipes/handPie.js';

export const island = {
  id: '2-island',
  name: 'Island',
  levels: [
    {
      tileSize: 256,
      size: 256,
      fallbackOnly: true,
    },
    {
      tileSize: 512,
      size: 512,
    },
    {
      tileSize: 512,
      size: 1024,
    },
    {
      tileSize: 512,
      size: 2048,
    },
  ],
  faceSize: 2048,
  initialViewParameters: {
    yaw: -0.011059512091840418,
    pitch: 0.595838567618669,
    fov: 1.4254872060750312,
  },
  linkHotspots: [
    {
      yaw: -0.031191031934081792,
      pitch: 0.23335188649610217,
      rotation: 0,
      target: '3-range',
    },
    {
      yaw: -0.6727085909746648,
      pitch: 0.1854974271643144,
      rotation: 5.497787143782138,
      target: '5-right',
    },
    {
      yaw: -1.652115908603161,
      pitch: 0.5684060588556541,
      rotation: 0,
      target: '4-left',
    },
    {
      yaw: -2.910804290489576,
      pitch: 0.6455464635754016,
      rotation: 0,
      target: '1-dining',
    },
    {
      yaw: 0.531191031934081792,
      pitch: 0.05335188649610217,
      rotation: -2.56415775814132,
      target: '0-countertop',
    },
  ],
  infoHotspots: [
    {
      yaw: -0.8749514333618968,
      pitch: 0.688368539820992,
      title: 'Large Muffin Pan',
      text: `
<ul>
<li><span class='b'> #100595</span></li>
<li> <span class='b'>USD</span> $29 | <span class='b'>CAD</span> $35</li>
<li> 3-year guarantee</li>
<li> Hand wash | Freezer-safe | PFOA-free</li>
<li> Heat-safe to 450°F (230°C) in conventional and convection ovens.</li>
<li> 14½" x 10" (37 cm x 25 cm); 6 wells: 1¼ cup (295 mL) each</li>
<li> Made from high-quality, durable carbon steel that evenly cooks baked goods. </li>
<li> The nonstick coating releases food easily and offers effortless cleanup and the blue enamel exterior makes it pretty.</li>
<li> Perfectly baked and browned sweet and savory favorites.</li>
<li> <span class='b'>Great for:</span> supersized muffins, stuffed peppers, pot pies, mini ice cream cakes, and individual-sized dinners.</li>
</ul>
        `,
      images: [
        { id: `iq4mm5ufsg`, key: `nc1-gs2-4` },
        { id: `bhsd0iyc7b`, key: `nc1-gs2-5` },
        { id: `nbgziw5rnt`, key: `nc1-gs2-6` },
        { id: `wu7ladgtak`, key: `nc1-gs2-7` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570017073" width="640" height="564" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe> `,
      ],
      recipes: largeMuffinPan.recipes,
    },
    {
      yaw: -1.0691613294726547,
      pitch: 0.5175606644673394,
      subhead: `9" (23-cm) Springform Pan`,
      title: 'Springform Pan',
      text: `
<ul>
<li><span class='b'> #100596</span></li>
<li> <span class='b'>USD</span> $29 | <span class='b'>CAD</span> $35</li>
<li> 3-year guarantee</li>
<li> Hand wash | Freezer-safe | PFOA-free</li>
<li> Heat-safe to 450°F (230°C) in conventional and convection ovens.</li>
<li> 9¼" x 3" (23.5 cm x 7.5 cm); 11¾ cups (2.75 L).</li>
<li> The carbon-steel material is durable, made to last, and ensures even baking, and the blue enamel exterior makes it pretty. </li>
<li> Removable bottom and sides make smooth, beautiful edges.</li>
<li> The locking system has a tight seal to help prevent leaking. </li>
<li> Nonstick coating releases food easily and offers effortless cleanup. </li>
<li> <span class='b'>Great for:</span> cheesecake, ice cream cakes, bread pudding, rigatoni pie, layered pasta dishes, and more.</li>
</ul>
`,
      images: [
        { id: `kvuw9vwylr`, key: `nc1-gs2-8` },
        { id: `wc5mzyhboq`, key: `nc1-gs2-9` },
        { id: `5nmptgknlx`, key: `nc1-gs2-10` },
        { id: `qbrjsvpmvx`, key: `nc1-gs2-11` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570000064" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],

      recipes: springFormPan.recipes,
    },
    {
      yaw: -0.27368957093927904,
      pitch: 0.6830678257097809,
      title: 'Baking Mixes',
      text: `
<ul>
<br/>
<span class="title">Brownie Mix</span>
<li><span class='b'> #100580</span></li>
<li><span class='b'>USD</span> $12 | <span class='b'>CAD</span> $16</li>
<li> Gluten-Free, Kosher, Dairy-Free, Vegan, Soy-Free, Non-GMO, and Made Without Nuts</li>
<li> 15.8 oz. (448 g); makes 16 brownies</li>
<li> Bake a batch of easy-to-make, easy-to-love fudgy, chewy brownies.</li>
<li> Made with allergen-free garbanzo bean flour and gluten-free oat flour.</li>
<li> Each brownie is just 100 calories and has 1 g of protein! For vegan brownies, just use vegan butter and a vegan egg substitute.</li>
<br/>
<span class="title">Chocolate Chip Cookie Mix</span>
<li> <span class="b">#100516</span></li>
<li> <span class="b">USD</span> $12 | <span class="b">CAD</span> $16</li>
<li> Gluten-Free, Kosher, Dairy-Free, Vegan, Soy-Free, Non-GMO, and Made Without Nuts</li>
<li> 13.5 oz. (383 g); makes 18 cookies</li>
<li> Bake a batch of easy-to-make, chocolate chip cookies.</li>
<li> Made with allergen-free garbanzo bean flour and gluten-free oat flour.</li>
<li> Each cookie is only 90 calories and has 1 g of protein. For vegan cookies, just use vegan butter and a vegan egg substitute.</li>
</ul>
        `,

      images: [
        { id: `cfs9dgr0xp`, key: `nc1-gs2-24` },
        { id: `blplg427nb`, key: `nc1-gs2-25` },
        { id: `6orawsbqbe`, key: `nc1-gs2-26` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999458" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
        `<iframe src="https://player.vimeo.com/video/569999628" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: -0.42685243868489664,
      pitch: 0.33719969299805896,
      title: 'Hand Pie &amp;<br/> Pocket Maker',
      text: `
<ul>
<li><span class='b'> #100601</span></li>
<li> <span class='b'>USD</span> $20 | <span class='b'>CAD</span> $26</li>
<li> 3-year guarantee</li>
<li> Dishwasher-safe</li>
<li> 5¼" x 4¾" x 1¾" (13.5 cm x 12.5 cm x 4.4 cm).<br/> Scoop: 1 tbsp (15 mL).</li>
<li> Includes the foldable base, dough cutter & mold, and spoon.</li>
<li> Easily cut, fill, and crimp tasty and impressive pies and pockets in a few simple steps.</li>
<li> Foldable base can make full-sized pockets or you can make half pockets by simply folding over to crimp and seal.</li>
<li> Top mold is used to crimp round pies and doubles as a cutter, so whether you’re using homemade or store-bought dough, it’ll be uniformly sized on the top and bottom.</li>
<li> Spoon ensures the perfect amount of filling. </li>
<li> All pieces nest for storage. </li>
<li> <span class='b'>Great for:</span> hand pies, empanadas, dumplings, pierogies, turnovers, pocket pies, and more.</li>
</ul>
        `,

      images: [
        { id: `oqtsmaahtm`, key: `nc1-gs2-16` },
        { id: `p4i50t7wfg`, key: `nc1-gs2-17` },
        { id: `nwjmjjlsna`, key: `nc1-gs2-18` },
        { id: `2ks6rw2foe`, key: `nc1-gs2-19` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570018193" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`,
      ],

      recipes: handPie.recipes,
    },
    {
      yaw: 0.7005490727936732,
      pitch: 0.13911890049504404,
      ...flexMultiPrep,
      recipes: flexPlus.recipes,
    },
    {
      yaw: 1.049640622082201,
      pitch: 0.5421631304098185,
      title: 'Plastic Mixing Bowl',
      subhead: '4-qt. (3.8 L) Plastic<br/> Mixing Bowl',
      text: `<ul>
<li><span class="b">#100471</span></li>
<li><span class="b">USD</span> $27 | <span class="b">CAD</span> $37</li>
<li> 3-year guarantee</li>
<li> Dishwasher-, microwave- and refrigerator-safe</li>
<li> Crafted from durable plastic in a pretty blue and cool gray design.</li>
<li> The perfect companion for mixing ingredients when using the Immersion Blender or Hand Mixer from our Flex+ Multi-Prep Set.</li>
<li> The wide lip lets you hold and pour from any angle and the nonslip ring keeps the bowl secure while mixing.</li>
<li><span class="b">Great for:</span> prepping foods or whipping up delicious batches of brownies, cakes, cookies, meatloaf, mashed potatoes, salads, dough, and more. </li>
</ul>`,
      images: [
        { id: `zvyzqzaf72`, key: `nc1-gs1-7` },
        { id: `r3uyu4mtnz`, key: `nc1-gs1-8` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999890" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: 0.7248855272852772,
      pitch: 0.6740943174834282,
      title: 'Bowl &amp; Bench Scraper Set',
      text: `<ul>
<li><span class="b">#100600</span></li>
<li><span class="b">USD</span> $24 | <span class="b">CAD</span> $30</li>
<li> 3-year guarantee</li>
<li> Dishwasher-safe</li>
<li> Bowl Scraper: 4" x 4¾" (10 cm x 12.5 cm).<br/> Bench Scraper: 5" x 6" (13 cm x 15 cm).</li>
<li> Includes one bench scraper (stainless steel) and one bowl scraper (flexible silicone).</li>
<li> These handy tools are prized by bakers and cooks alike. Both nest together to store.</li>
<li> Bowl Scraper has one square side for hard-to-reach corners, and one rounded side, so you can cleanly scrape many types of bowls and plates.</li>
<li> Bench Scraper has a stainless blade and both imperial and measurement markings. Chop, divide, scrape, scoop, and transfer ingredients to a bowl, pan or from work surfaces.</li>
<li> <span class="b">Great for:</span> dry and wet doughs, batters, nuts, and bar cookies.</li>
</ul>`,
      images: [
        { id: `umtth3b6e3`, key: `nc1-gs1-9` },
        { id: `nypbnd1832`, key: `nc1-gs1-10` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570014825" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
  ],
};
